module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "additional-infos"
  }, [_c('div', {
    staticClass: "additional-infos__item"
  }, [(_vm.hasIcon('aaa')) ? _c('div', {
    staticClass: "additional-infos__item__text additional-infos__item__text--aaa",
    attrs: {
      "tabindex": "0",
      "aria-label": "Awards label and year of obtention"
    }
  }, [_c('img', {
    attrs: {
      "src": require("assets/icons/logo-aaa.png")
    }
  }), _c('span', [_vm._v(_vm._s(_vm.currentFarm.config.infos.aaa.year))])]) : _vm._e(), (_vm.hasIcon('rainforest')) ? _c('img', {
    attrs: {
      "src": require("assets/icons/logo-rac.png")
    }
  }) : _vm._e(), (_vm.hasIcon('fairtrade')) ? _c('img', {
    attrs: {
      "src": require("assets/icons/logo-ftc.jpg")
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "additional-infos__item additional-infos__item--coffee"
  }, [_c('img', {
    attrs: {
      "src": require("assets/icons/coffee.svg")
    }
  }), _c('div', {
    staticClass: "additional-infos__item__text",
    attrs: {
      "tabindex": "0",
      "aria-label": "Coffee cultivated"
    }
  }, [_vm._v(_vm._s(_vm.currentFarm.config.infos.coffee))])]), _c('div', {
    staticClass: "additional-infos__item additional-infos__item--caps"
  }, [_c('img', {
    attrs: {
      "src": require("assets/icons/capsule_nes.svg")
    }
  }), _c('div', {
    staticClass: "additional-infos__item__text",
    attrs: {
      "tabindex": "0",
      "aria-label": "Caps"
    }
  }, [_vm._v(_vm._s(_vm.currentFarm.config.infos.grand_crus))])]), _c('div', {
    staticClass: "additional-infos__item additional-infos__item--mountain"
  }, [_c('img', {
    attrs: {
      "src": require("assets/icons/mountain.svg")
    }
  }), _c('div', {
    staticClass: "additional-infos__item__text",
    attrs: {
      "tabindex": "0",
      "aria-label": "Farm altitude"
    }
  }, [_c('big', [_vm._v(_vm._s(_vm.currentFarm.config.location.altitude))])], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3132b5b9", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3132b5b9"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/additional-infos/AdditionalInfosComponent.vue
// module id = 815
// module chunks = 0